import { get } from 'lodash'

import type { CloudMarketplace } from '../../productsListing/types'
import type { Contract } from '../types'

export const getSendContractsObjectToSend = (
  contractsData: Contract[],
  payload: Record<string, unknown>,
  selectedCloudProvider: CloudMarketplace
): Record<string, unknown> =>
  selectedCloudProvider === 'AWS'
    ? payload
    : {
        product_id: get(contractsData, '[0].productId'),
        ...(selectedCloudProvider === 'GCP'
          ? {
              cloud_marketplace: get(contractsData, '[0].cloudMarketplace'),
              cloud_marketplace_product_id: get(
                contractsData,
                '[0].cloudMarketplaceProductId'
              ),
            }
          : {}),
        usage: payload,
      }
